'use client';
import { useTranslations } from 'next-intl';
import { ComponentPropsWithoutRef, useContext } from 'react';
import { useGetLocalizedValue } from '@/shared/lib/hooks/useGetLocalizedValue';
import * as Tabs from '@/shared/ui/tabs';
import './product-detail.scss';
import { ProductDetailContext } from './provider';

type Props = ComponentPropsWithoutRef<typeof Tabs.Root>;

export const ProductDetailDetails = (props: Props) => {
    const t = useTranslations();
    const { currentItem } = useContext(ProductDetailContext);
    const getLocalizedValue = useGetLocalizedValue();
    const description = getLocalizedValue(currentItem?.description ?? {}).trim();
    if (!description) return null;

    return (
        <Tabs.Root id="detail" defaultValue="description" {...props}>
            <Tabs.List>
                <Tabs.Trigger value="description">{t('WORDS.DESCRIPTION')}</Tabs.Trigger>
            </Tabs.List>
            <Tabs.Content value="description">
                <p
                    className="product-detail__details-content"
                    data-testid="product-detail-details-description"
                >
                    {description}
                </p>
            </Tabs.Content>
        </Tabs.Root>
    );
};
